const ID_TOKEN_KEY = "id_token";

export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = token => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export const saveUserId = userId  => {
  window.localStorage.setItem('uId', userId);
};
export const getUserId = () => {
  return window.localStorage.getItem('uId');
};

export const destroyUserId = () => {
  window.localStorage.removeItem('uId');;
};

export const saveRoles = roles  => {

  let arrRoles = roles.map(a => a.idRol);

  window.localStorage.setItem('roles', JSON.stringify(arrRoles));
  //console.log(arrRoles)
};

export const destroyRoles = () => {
  window.localStorage.removeItem('roles');
  window.localStorage.removeItem('rolId');
};

export const getRoles = () => {
  return window.localStorage.getItem('roles');
};


export const getRolId = () => {
  return window.localStorage.getItem('rolId');
};

export const saveStateId = statesId => {
  window.localStorage.setItem('srstatesid', statesId);
};

export const getStateId = () => {
  return window.localStorage.getItem('srstatesid');
};

export const saveCreadorDepartamental = datosCreador => {
  window.localStorage.setItem('creadorDepartamentoNombre', datosCreador.creadorDeptoNombre);
  window.localStorage.setItem('creadorDepartamentoId', datosCreador.creadorDepartamentoId)
}

export const destroyCreadorDepartamental = () => {
  window.localStorage.removeItem('creadorDepartamentoNombre');
  window.localStorage.removeItem('creadorDepartamentoId');
};

export const getCreadorDepartamentalNombre = () => {
  return window.localStorage.getItem('creadorDepartamentoNombre');
  
}

export const getCreadorDepartamentaId = () =>{
  return window.localStorage.getItem('creadorDepartamentoId')
}


export const saveInstitucion = datosUsuario => {
  window.localStorage.setItem('institucionNombre', datosUsuario.institucion);
  window.localStorage.setItem('institucionId', datosUsuario.institucionesId)
}

export const destroyInstitucion = () => {
  window.localStorage.removeItem('institucionNombre');
  window.localStorage.removeItem('institucionId');
};



export const getInstitucionNombre = () => {
  return window.localStorage.getItem('institucionNombre');
  
}

export const getInstitucionId = () =>{
  return window.localStorage.getItem('institucionId')
}





export default { 
    getToken, 
    saveToken, 
    destroyToken, 
    saveUserId, 
    getUserId, 
    destroyUserId,
    saveRoles,
    getRoles,
    destroyRoles, 
    getRolId, 
    saveStateId, 
    getStateId, 
    saveCreadorDepartamental, 
    destroyCreadorDepartamental, 
    saveInstitucion,
    destroyInstitucion,
    getInstitucionNombre, 
    getInstitucionId 
  };
